<template>
  <div class="bg-light-100 text-left dark:bg-dark-800 rounded-xl p-3" v-if="nonprofit">
    <div class="flex items-center space-x-3">
      <div class="size-10 bg-contain rounded-md bg-center shrink-0" :style="{ backgroundImage: `url(${nonprofit.logo})` }" />
      
      <p class="font-bold text-md leading-tight" v-if="isSubscribe">
        {{ $t('components.Nonprofit.subscribe.title') }}
      </p>
      <p class="font-bold text-md leading-tight" v-else>
        {{ $t('components.Nonprofit.referrals.title') }}
      </p>
    </div>

    <div class="mt-3">
      {{ nonprofit.description }} <ButtonLink @click="() => isPopin = true">
        {{ $t('actions.learnMore') }}
      </ButtonLink>
    </div>

    <div class="bg-light-300 dark:bg-dark-700 p-3 rounded-md mt-4 flex items-center space-x-2">
      <ImageEmoji name="Coin" size="sm" class="size-6" />

      <div class="grow" v-if="isSubscribe">
        <p class="text-md font-medium leading-tight">
          {{ $t('components.Nonprofit.amount', { amount: round(referralAmountTotal, 2) }) }}
        </p>
      </div>
      <div class="grow" v-else>
        <p class="text-xs text-light-800 dark:text-dark-400">{{ $t('components.Nonprofit.amount', { amount: round(referralAmountTotal, 2) }) }}</p>

        <p class="text-md font-medium leading-tight">
          {{ $t('components.Nonprofit.amountSelf', { amount: round(referralAmount ?? 0, 2) }) }}
        </p>
      </div>
    </div>

    <PopinBase :is-active="isPopin" size="2xs" is-outer-close @close="isPopin = false">
      <template #body>
        <div class="p-4 text-body" v-html="nonprofit.description" />
      </template>
    </PopinBase>
  </div>
</template>

<script lang="ts" setup>
import UserStore from '@/store/user'
import { userNonprofitAmountGetAPI } from '~/api/user'

const props = withDefaults(defineProps<{
  referralAmount?: number
  isSubscribe?: boolean
}>(), {
  isSubscribe: false
})

const referralAmountTotal = ref(0)

const isPopin = ref(false)

const userStore = UserStore()
const { currentUser, nonprofit } = storeToRefs(userStore)

onMounted(async () => {

  const response = await userNonprofitAmountGetAPI()
  if (response.ok) {
    referralAmountTotal.value = response.data.amount
  }
})

</script>